function brochureFormIsInSection(form, section) {
	if (!section || !form) {
		return false;
	}
	if (form.nodeType === 1 && section.contains(form)) {
		return true;
	}
	return false;
}

function brochureFormFromEvent(event, section) {
	var form = event && event.target;
	if (form && form.nodeType === 1) {
		if (form.classList && form.classList.contains('wpcf7-form')) {
			return form;
		}
		if (form.closest) {
			var closestForm = form.closest('.wpcf7-form, .wpcf7');
			if (closestForm) {
				return closestForm;
			}
		}
	}

	var detail = null;
	if (event) {
		if (event.detail) {
			detail = event.detail;
		} else if (event.originalEvent && event.originalEvent.detail) {
			detail = event.originalEvent.detail;
		}
	}
	if (!detail) {
		return null;
	}

	if (detail.unitTag) {
		var unit = document.getElementById(detail.unitTag);
		if (unit) {
			return unit.querySelector('.wpcf7-form') || unit;
		}
	}

	if (detail.contactFormId) {
		var id = String(detail.contactFormId);
		var match = section.querySelector('input[name="_wpcf7"][value="' + id + '"]');
		if (match) {
			return match.closest('.wpcf7-form') || match.closest('.wpcf7');
		}
	}

	return null;
}

function revealBrochurePdfs(section) {
	if (!section || section.classList.contains('rml-brochure--sent')) {
		return;
	}

	section.classList.add('rml-brochure--sent');

	var intro = section.querySelector('#title-brochure');
	var formWrap = section.querySelector('.rml-brochure__form');
	var pdfs = section.querySelector('#pdf-selector-container');

	if (intro) {
		intro.style.setProperty('display', 'none', 'important');
	}
	if (formWrap) {
		formWrap.style.setProperty('display', 'none', 'important');
	}
	if (pdfs) {
		pdfs.removeAttribute('hidden');
		pdfs.style.setProperty('display', 'block', 'important');
	}
}

function onBrochureMailSent(event, section) {
	var form = brochureFormFromEvent(event, section);

	if (form) {
		if (!brochureFormIsInSection(form, section)) {
			return;
		}
		revealBrochurePdfs(section);
		return;
	}

	var id = event && event.detail ? String(event.detail.contactFormId || '') : '';
	if (!id || !section.querySelector('input[name="_wpcf7"][value="' + id + '"]')) {
		return;
	}

	revealBrochurePdfs(section);
}

function initRmicrofibreBrochure() {
	var section = document.getElementById('download-brochure');
	if (!section) {
		return;
	}

	var onMailSent = function (event) {
		onBrochureMailSent(event, section);
	};

	document.addEventListener('wpcf7mailsent', onMailSent);

	if (window.jQuery) {
		window.jQuery(document).on('wpcf7mailsent', onMailSent);
	}

	var forms = section.querySelectorAll('.wpcf7-form');
	if (forms.length && window.MutationObserver) {
		var observer = new MutationObserver(function () {
			if (section.querySelector('.wpcf7-form.sent')) {
				revealBrochurePdfs(section);
			}
		});
		forms.forEach(function (form) {
			observer.observe(form, { attributes: true, attributeFilter: ['class'] });
		});
	}

	if (section.querySelector('.wpcf7-form.sent')) {
		revealBrochurePdfs(section);
	}

	var button = document.getElementById('btn-open-pdf');
	var select = document.getElementById('pdf-select');
	if (!button || !select || button.dataset.rmlBound === '1') {
		return;
	}

	button.dataset.rmlBound = '1';
	button.addEventListener('click', function () {
		var pdf = select.value;
		if (pdf) {
			window.open(pdf, '_blank');
		}
	});
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initRmicrofibreBrochure);
} else {
	initRmicrofibreBrochure();
}
